import React from 'react';
import Section from './Section';
import TextInput from '../Form/TextInput/TextInput';
import { formatDate } from '../../utils/helpers';

/** @import {FisaProductData} from './MyAccountTypes' */

const formatter = (/** @type {Date | undefined} */ date) => {
  if (date) {
    return `${formatDate(new Date(date))} 23:59`;
  }

  return '';
}

const tooltipContent = () => (
  <>
    <h3 className="tooltip__blended-title">Why do I have limited time?</h3>
    <p className="tooltip__blended-item">Your funding window is the seven-day period during which you can make deposits into this account. You won't be able to make any withdrawals during this time, and when it ends, you won't be able to deposit any more money.</p>
  </>
)

function FisaFundingWindow(/** @type {{profileData: FisaProductData}} */ props) {
  return (
    <>
      <Section title="Funding window closes" hideEditing={true} showTooltip={true} toolTipId="fwToolTip" tooltipContent={tooltipContent()}>
        <TextInput className="my-account__input" value={formatter(props.profileData.fundingEndDate)} label='Closes on' disabled />
      </Section>
    </>
    );
};

export default FisaFundingWindow;